module.exports = __webpack_public_path__ + "static/media/bamboohr.78f1403f.svg";